import $ from 'jquery';

function currentStylesheets() {
  let links = document.querySelectorAll("link");
  links = Array.prototype.slice.call(links);

  return links
    .filter(function (l) {
      return l.rel == "stylesheet" && l.rel == "text/css";
    })
    .map(function (l) {
      return l.href;
    });
}

function commaSeparated(arr) {
  return arr.join(",");
}

export function sisPrintRelatorio() {
  let $tbMaster = $("#tbMaster");
  $tbMaster.removeClass('table');

  let extraCss = commaSeparated(currentStylesheets());

  $("#printable").printArea({
    extraCss: extraCss
  });

  $tbMaster.addClass('table');
}



// WEBPACK FOOTER //
// ./resources/js/js_relatorio.js